import { render, staticRenderFns } from "./WriteOffSum.vue?vue&type=template&id=95b2e348&scoped=true&"
import script from "./WriteOffSum.vue?vue&type=script&lang=js&"
export * from "./WriteOffSum.vue?vue&type=script&lang=js&"
import style0 from "./WriteOffSum.vue?vue&type=style&index=0&id=95b2e348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b2e348",
  null
  
)

export default component.exports